import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const DashboardPage = lazy(() => import('./views/dashboard'));

const dashboard1Routes: RouteObject = {
	id: 'dashboard-1',
	path: '/',
	element: <DashboardPage />,
};

export default dashboard1Routes;
